<template>
  <div id="contenedor-editar-entidad">
    <v-form
      v-model="esFormularioValido"
      ref="editarEntidad">
      <v-card>
        <v-card-title class="secondary--text">
          Editar entidad
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Nombre de la Entidad"
            v-model="entidad.nombre"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarEntidad"
            required
          ></custom-text-field>
          <custom-text-field
            label="Nombre Corto de la Entidad"
            v-model="entidad.nombreCorto"
            :rules="[mixReglas.requerido]"
            v-on:keypress.enter="mixActualizarEntidad"
            required
          ></custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarEntidad"
            :disabled="!esFormularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoEntidades from './mixCatalogoEntidades';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoEntidadesEditar',
  mixins: [mixCatalogoEntidades],
  props: {
    entidadEditar: Object,
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      entidad: {
        nombre: this.entidadEditar.nombre,
        nombreCorto: this.entidadEditar.nombreCorto,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.editarEntidad.reset();
    },
  },
};
</script>

<style lang="scss">
</style>
